import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { changeTheme, localFetch } from "@/utils/util";
import { UI_THEMES } from "@/utils/const";
import Menu from "primevue/menu";
import Button from "primevue/button";
import { MenuPt } from "@/utils/globalPassThrough";
export default {
  name: "ThemeSelector",
  // eslint-disable-next-line vue/no-reserved-component-names
  components: {
    Button,
    Menu
  },
  methods: {
    localFetch,
    setTheme(theme) {
      changeTheme(theme);
      this.$store.commit("uiConfigStore/setCurrentTheme", theme);
    },
    toggleMenu(event) {
      this.$refs.menu.toggle(event);
    }
  },
  computed: {
    MenuPt() {
      return MenuPt;
    },
    selectedThemeOption() {
      const saved = localFetch("saved_ui_theme") || UI_THEMES.SYSTEM;
      return this.options.find(o => o.value === saved);
    }
  },
  data() {
    return {
      options: [{
        icon: "pi pi-sun",
        label: this.$tf("profile.colorScheme.light|Világos"),
        value: UI_THEMES.LIGHT
      }, {
        icon: "pi pi-moon",
        label: this.$tf("profile.colorScheme.dark|Sötét"),
        value: UI_THEMES.DARK
      }, {
        icon: "pi pi-cog",
        label: this.$tf("profile.colorScheme.system|Rendszerbeállítás"),
        value: UI_THEMES.SYSTEM
      }]
    };
  }
};